module.exports = __webpack_public_path__ + "img/csv.b02613c0.svg";